<div class="mx-auto max-w-7xl px-4 py-10">
    <div class="flex flex-wrap items-end justify-between gap-4 mt-2">
        <div>
            <h1 class="!mb-1 !text-5xl !font-bold !tracking-tight !text-strong">
                Dashboard
            </h1>
            <p class="!mb-0 !text-lg !leading-relaxed !text-subtle">
                Qui trovi tutte le convocazioni o puoi crearne una nuova.
            </p>
        </div>
    </div>

    <app-dashboard-mister-convocations-row
        [convocations]="convocations"
        [loading]="convocationsLoading"
        [showDraftActions]="true"
        [statusUpdatingId]="statusUpdatingId"
        (openCreate)="formOpen = true"
        (approveDraft)="onApproveDraft($event)"
        (cancelDraft)="onCancelDraft($event)"
    ></app-dashboard-mister-convocations-row>

    <app-dashboard-mister-latest-convocation-card
        [convocation]="latestConvocation"
        [invitedUsers]="latestInvitedUsers"
        [loading]="convocationsLoading"
        [invitedLoading]="latestInvitedLoading"
    ></app-dashboard-mister-latest-convocation-card>

    <app-dashboard-mister-convocations-table
        [convocations]="convocations"
        [loading]="convocationsLoading"
        [showDraftActions]="true"
        [statusUpdatingId]="statusUpdatingId"
        (approveDraft)="onApproveDraft($event)"
        (cancelDraft)="onCancelDraft($event)"
    ></app-dashboard-mister-convocations-table>
</div>

<app-mister-convocation-form
    [isOpen]="formOpen"
    [convocation]="null"
    (closed)="formOpen = false"
    (saved)="onNewConvocationSaved($event)"
></app-mister-convocation-form>
